var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"p-0"},[_c('b-row',{staticClass:"my-2 mx-0"},[_c('b-col',[_c('h5',{staticClass:"font-weight-bold"},[_vm._v("Import CSV")]),_c('hr')])],1),_c('divalto-import'),_c('b-button',{attrs:{"variant":"primary"},on:{"click":function($event){return _vm.downloadSampleFile()}}},[_vm._v(" Download Sample File ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }